import { Chip } from '@mui/material';
import { toInt } from 'utils/numberUtils';

export const getTagName = (labels, tagCode) => {
  return labels.find((x) => x.LABEL_CD == tagCode)?.DISPLAY;
};

// 工事タグコンポーネント
export const KoujiTagComponent = (props) => {
  const labels = props.labels;
  const tagCode = toInt(props.tagCode);

  let tagName = getTagName(labels, tagCode);

  // タグが消された場合は表示しない
  if (!tagName) {
    return <></>;
  }

  return (
    <Chip
      className="m-1"
      style={{
        width: props.width,
        minWidth: '72px',
        color: '#feffe6',
        backgroundColor: '#ec8b4a',
      }}
      size="small"
      label={tagName}
      onClick={props.onClick ? () => props.onClick() : null}
      onDelete={props.onDelete ? () => props.onDelete(props.tagCode) : null}
    />
  );
};
